import { FC, lazy } from 'react';
import { useOurProfiler } from 'src/hooks/use-our-profiler';
import { usePlatformSettings } from 'src/pages/reporting/use-platform-settings';

const Page = lazy(() => import('./page'));

export const ReportingAuctions: FC = () => {
  const platformSettings = usePlatformSettings();
  useOurProfiler('ReportingAuctions');
  return <Page platformSettings={platformSettings} />;
};
